<div [formGroup]="subForm">
  <div class="mt-3">
    <span *hasPermission="Permission.CATALOG_MANAGE"
      [showWhen]="canEditCatalog"><strong>{{variables.addChangeRemoveTask}}.</strong></span>
    <span *hasPermission="Permission.CATALOG_MANAGE "
      [showWhen]="!canEditCatalog"><strong>{{variables.catalogTasks}}</strong></span>

    @if (listItemActions && listItemActions.length > 0) {
    <div class="row">
      <div class="col-12">
        <div class="d-flex list-group-control-header header-sticky header-top-border mt-3" style="align-items: center;">
          <div style="flex-basis: 25%;"></div>
          <div style="flex-basis: 18%;">{{variables.effort}} ({{variables.hours}})</div>
          <div style="flex-basis: 36%;">{{variables.tshirtSizes}} ({{variables.days}})</div>
          <div style="flex-basis: 8%;"></div>
          <div style="flex-basis: 7%;"></div>
        </div>
      </div>
      <div class="col-12">
        <div class="d-flex list-group-control-header header-sticky header-middle-border mt-3"
          style="align-items: center; margin-top: 0 !important;">
          <div style="flex-basis: 25%;">{{variables.name}}</div>
          <div style="flex-basis: 6%;">{{variables.low}}</div>
          <div style="flex-basis: 6%;">{{variables.medium}}</div>
          <div style="flex-basis: 6%;">{{variables.high}}</div>
          <div style="flex-basis: 6%;">XS</div>
          <div style="flex-basis: 6%;">S</div>
          <div style="flex-basis: 6%;">M</div>
          <div style="flex-basis: 6%;">L</div>
          <div style="flex-basis: 6%;">XL</div>
          <div style="flex-basis: 6%;">XXL</div>
          <div style="flex-basis: 8%;">{{variables.profile}}</div>
          <div style="flex-basis: 7%;"></div>
        </div>
      </div>
    </div>
    }

    @if (listItemActions && listItemActions.length > 0) {
    <div class="list-group-control" cdkScrollable>
      <div cdkDropList (cdkDropListDropped)="dropTable($event)">
        @for (item of listItemActions; track item) {
        <div class="list-group-control-item d-flex" cdkDrag style="align-items: center;">
          <div style="flex-basis: 25%;">{{item.name}}</div>
          <div style="flex-basis: 6%;">{{ item.complexityLow}}</div>
          <div style="flex-basis: 6%;">{{ item.complexityMedium}}</div>
          <div style="flex-basis: 6%;">{{ item.complexityHigh}}</div>
          <div style="flex-basis: 6%;">{{ item.tshirtXS ? item.tshirtXS : '-' }}</div>
          <div style="flex-basis: 6%;">{{ item.tshirtS ? item.tshirtS : '-' }}</div>
          <div style="flex-basis: 6%;">{{ item.tshirtM ? item.tshirtM : '-' }}</div>
          <div style="flex-basis: 6%;">{{ item.tshirtL ? item.tshirtL : '-' }}</div>
          <div style="flex-basis: 6%;">{{ item.tshirtXL ? item.tshirtXL : '-' }}</div>
          <div style="flex-basis: 6%;">{{ item.tshirtXXL ? item.tshirtXXL : '-' }}</div>
          <div style="flex-basis: 8%;">{{ getProfileName(item.profileId) }}</div>
          <div class="list-group-control-item-icons action_buttons" style="flex-basis: 7%; align-items: center;">
            <span *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="canEditCatalog"
              (click)="openDialogEditProject(item)" matTooltip="{{variables.editTasks}}"
              class="icon-edit me-3 action_buttons-item">
              <img src="../../../../assets/svg/EditWhite.svg" alt="Edit Icon" width="20px">
            </span>
            <span *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="canEditCatalog"
              (click)="openDialogRemove(item.name)" matTooltip="{{variables.removeTasks}}"
              class="icon-close me-1 action_buttons-item">
              <img src="../../../../assets/svg/BinWhite.svg" alt="Delete Icon" width="15px">
            </span>
          </div>
        </div>
        }
      </div>
    </div>
    }
    <br>
    <div class="mt-3"></div>
    <app-button *hasPermission="Permission.CATALOG_MANAGE" [showWhen]="canEditCatalog" typeBtn="primary"
      class="addItemsInCatalogStepBtn" (click)="openDialogProject()" message="{{variables.addTask}}"></app-button>
  </div>
</div>